import { useEffect, type MutableRefObject } from "react";

import { getScrollbarWidth, isBrowser } from "../model/utils";

export const useBodyScrollLock = (
    shouldLock: boolean,
    disable: boolean,
    originalOverflowRef: MutableRefObject<string>,
    originalPaddingRightRef: MutableRefObject<string>
) => {
    useEffect(() => {
        if (!isBrowser() || disable || !shouldLock) {
            return undefined;
        }

        const { body, documentElement } = document;

        if (!body || !documentElement) {
            return undefined;
        }

        originalOverflowRef.current = body.style.overflow;
        originalPaddingRightRef.current = body.style.paddingRight;

        const scrollbarWidth = getScrollbarWidth();

        body.style.overflow = "hidden";

        if (scrollbarWidth > 0) {
            body.style.paddingRight = `${scrollbarWidth}px`;
        }

        return () => {
            body.style.overflow = originalOverflowRef.current;
            body.style.paddingRight = originalPaddingRightRef.current;
        };
    }, [disable, shouldLock, originalOverflowRef, originalPaddingRightRef]);
};
